import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons';

import Filter from './filter';
import PropertyTypeFilter from './property_type_filter';

export default function CompSaleFilters({ query, onChange }) {
  return <React.Fragment>
    <Filter
      className="form-select"
      label="On market or sold"
      name="onMarketEq"
      query={query}
      type="select"
      onChange={onChange}
    >
      <option value="">Both</option>
      <option value="true">On market</option>
      <option value="false">Sold</option>
    </Filter>

    <PropertyTypeFilter query={query} onChange={onChange} />

    <Filter
      label="Sale Price"
      name="price"
      query={query}
      range
      unitLabel="$"
      onChange={onChange}
    />

    <Filter
      label="Size (SF)"
      name="researchPropertyBuildingSize"
      query={query}
      range
      unitLabel="SF"
      onChange={onChange}
    />

    <Filter
      label="Lot Size (Acres)"
      name="researchPropertyLotSize"
      query={query}
      range
      unitLabel="AC"
      onChange={onChange}
    />

    <Filter
      label="Sold/Listed Date"
      name="saleDate"
      query={query}
      range
      unitLabel={<FontAwesomeIcon icon={faCalendarAlt} />}
      onChange={onChange}
    />
  </React.Fragment>;
}

CompSaleFilters.propTypes = {
  query: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
